export const BRAND = {
  name: "CROSSBAR AGENCY",
  short: "CROSSBAR",
  tagline: "Global Sports Advisory",
  email: "hello@crossbaragency.com",
  phone: "+34 660 124 730",
  phoneAlt: "+44 (0) 7850 453075",
  logo: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/4ycvcn2v_crossbar-wordmark-white-transparent.png",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/35898730/pexels-photo-35898730.jpeg",
  founder: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/i2lswfel_IMG_1505.jpg",
  athlete: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  stadium: "https://images.pexels.com/photos/28827841/pexels-photo-28827841.jpeg",
};

export const SEGMENTS = [
  {
    id: "brands",
    kicker: "01 / For Brands",
    title: "Growth, Powered by Sport.",
    items: [
      {
        title: "Sponsorship Strategy",
        desc: "Data-driven alignment connecting your brand with high-impact sports properties across the globe.",
      },
      {
        title: "Activation & Experiential",
        desc: "Immersive fan experiences that transcend traditional media and build genuine, lasting brand loyalty.",
      },
      {
        title: "Naming Rights & Premium Assets",
        desc: "Valuation and negotiation of tier-one assets, from stadium naming rights to jersey-front placements.",
      },
    ],
  },
  {
    id: "athletes",
    kicker: "02 / For Sports Entities & Athletes",
    title: "The right brands. The right fit.",
    items: [
      {
        title: "Commercial Rights Packaging",
        desc: "Structuring your IP and assets to maximize market value and attract blue-chip commercial partners.",
      },
      {
        title: "Talent Brand Representation",
        desc: "Building personal brand equity and securing lucrative, authentic long-term endorsement deals.",
      },
      {
        title: "Revenue Diversification",
        desc: "Identifying new monetization channels including digital, bespoke merchandise, and content ventures.",
      },
    ],
  },
  {
    id: "partners",
    kicker: "03 / For Partners",
    title: "Partnerships, handled end to end.",
    items: [
      {
        title: "Full Sponsorship Management",
        desc: "We run the entire function: identifying opportunities, managing relationships, and closing agreements.",
      },
      {
        title: "Investment Advisory",
        desc: "Due diligence and strategic counsel for sports-tech ventures and franchise acquisitions.",
      },
      {
        title: "Global Market Entry",
        desc: "Navigating complex sports markets with local cultural and commercial intelligence on the ground.",
      },
    ],
  },
];

export const STATS = [
  { value: "$70M+", label: "Deal Value Negotiated" },
  { value: "7+", label: "Years in Elite Sports" },
  { value: "40+", label: "Global Brands Advised" },
];

export const PARTNERS = [
  { name: "MVPs.com", logo: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/hcxcc7is_image.png" },
  { name: "Panini", logo: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/see7eirp_image.png" },
  { name: "Topps", logo: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/omzxxpi6_image.png" },
  { name: "Beats by Dr. Dre", logo: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/i9k2zr1o_image.png" },
  { name: "adidas", logo: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/r1hqtrcq_image.png", big: true },
  { name: "Nike", logo: "https://customer-assets.emergentagent.com/job_edu-connect-364/artifacts/6gkx7gqb_image.png" },
];
